module.exports = ['$resource', $resource => $resource('/api/v2/patients/:patientId/linked_patients',
  {
    id: '@id',
    patientId: '@patientId',
  },
  {
    query: {
      method: 'get',
      isArray: true,
    },
    post: {
      method: 'post',
      transformRequest: (data) => {
        const requestData = angular.merge({}, data);
        delete requestData.$resolved;
        delete requestData.$promise;
        delete requestData.patientId;

        return angular.toJson(_.mapKeys(requestData, (value, key) => _.snakeCase(key)));
      },
    },
  },
  )];



// WEBPACK FOOTER //
// ./main/factories/linked-patient-resource.js